module.exports = __webpack_public_path__ + "static/media/luton.b7128268.png";